<template>
  <div class="chatItem">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt="用户头像" />
    </div>
    <div class="chatWrap">
      <div class="nickname">{{ chatItem.nickname || '匿名用户' }}</div>
      <div class="cardMsg">
        <div class="cardHeader">
          <span class="cardTag">名片</span>
          <button
              v-if="showEditButton"
              class="edit-btn"
              @click.stop="handleEdit"
          >
            修改名片
          </button>
        </div>
        <div class="cardContent" @click="onExchange">
          <div class="info">
            <div class="company">{{packageObj.company}}</div>
            <div class="position">{{packageObj.position}}</div>
            <div class="divider"></div>
            <div class="intro">{{ packageObj.intro }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 保留原有的邮箱弹窗 -->
    <van-popup v-model="showEditEmail"
               position="bottom"
               round
               :style="{ height: '30%' }">
      <van-nav-bar
          title="填写接收邮箱"
          left-text="返回"
          @click-left="showEditEmail=false"
          left-arrow
      />
      <div class="email-form">
        <van-field
            v-model="email"
            type="email"
            label="邮箱地址"
            placeholder="请输入您的邮箱"
            clearable
            :error-message="errorMsg"
            @blur="validateEmail"
        />
        <div class="submit-btn">
          <van-button
              type="primary"
              size="large"
              :disabled="!isValid"
              @click="handleSubmit"
          >
            提交
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import { mapGetters } from "vuex";
import { Dialog, NavBar } from "vant";
import wx from "weixin-js-sdk";

export default {
  name: "ChatCard",
  props: {
    chatItem: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    [NavBar.name]: NavBar,
  },
  computed: {
    ...mapGetters(["live", "userInfo","appConfig"]),
    packageObj() {
      try {
        return JSON.parse(this.chatItem.chatContext);
      } catch (e) {
        return {
          company: '',
          position: '',
          intro: '',
          id: ''
        };
      }
    },
    showEditButton() {
      return this.userInfo.id === this.packageObj.id.toString();
    },
  },
  data() {
    return {
      email: '',
      errorMsg: '',
      isValid: false,
      showEditEmail: false,
      defaultAvatar: defaultAvatar
    }
  },
  methods: {
    validateEmail() {
      const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

      if (!this.email) {
        this.errorMsg = '请输入邮箱地址';
        this.isValid = false;
      } else if (!reg.test(this.email)) {
        this.errorMsg = '请输入有效的邮箱格式';
        this.isValid = false;
      } else {
        this.errorMsg = '';
        this.isValid = true;
      }
    },
    handleSubmit() {
      if (!this.isValid) return;
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });

      this.$http.post('/user/setEmail', { email: this.email }).then(() => {
        this.$toast.success('设置成功,可以交换名片了！');
        this.showEditEmail = false;
        this.$emit('set-email');
      }).catch(() => {
        this.$toast.fail('设置失败，请重试');
      });
    },
    onExchange() {
      if (this.userInfo.id === this.packageObj.id.toString()) {
        this.handleEdit();
        return;
      }
      if (!this.userInfo.email) {
        this.showEditEmail = true;
        return;
      }
      Dialog.confirm({
        title: '交换名片（消耗100金币）',
        message: '对方如果同意，名片会发到您的邮箱里！（新用户赠送3次）',
      }).then(() => {
        return this.$http.get(`/chat/reqExchangeCard?toICloudUserId=${this.packageObj.uid}&liveId=${this.live.id}`);
      }).then(res => {
        if(res.data){
          this.$Bus.$emit("refreshCoin");
          this.$toast.success('发送成功！');
        }else{
          this.$toast.fail('金币不足！');
          if(this.appConfig.rechargeSwitch!=='1'){
            wx.miniProgram.navigateTo({
              url: `/pages/recharge/recharge`,
            });
          }else{
            wx.miniProgram.navigateTo({
              url: `/pages/chongzhi/chongzhi`,
            });
          }
        }
      }).catch(err => {
        console.log(err);
        this.$toast.fail('发送失败，请重试');
      });
    },
    handleEdit() {
      this.$emit('edit-card', this.packageObj);
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  animation: fadeIn 0.5s ease;

  .userInfo {
    margin-left: 25px;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 2px solid #576B95; // 改为蓝色系
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 6px;
    //border: 1px solid #F34;

    .nickname {
      color: #576B95; // 蓝色系
      font-size: 12px;
      margin-bottom: 3px;
      background-color: rgba(87, 107, 149, 0.1);
      padding: 3px 6px;
      border-radius: 3px;
      font-weight: bold;
    }

    .cardMsg {
      min-width: 230px;
      font-size: 13px;
      font-weight: 500;
      line-height: 1.5;
      color: #333;
      overflow-wrap: break-word;
      background: #ffffff;
      padding: 0;
      border-radius: 7px;
      max-width: 280px;
      position: relative;
      border: 1px solid #e0e0e0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      .cardHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid #f0f0f0;
        background-color: #f9f9f9;
        border-radius: 7px 7px 0 0;

        .cardTag {
          display: inline-block;
          background-color: #576B95; // 蓝色系
          color: white;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 3px;
          font-weight: bold;
        }

        .edit-btn {
          padding: 2px 8px;
          background: #576B95;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 10px;
          cursor: pointer;
          transition: all 0.3s;
          margin-right: 20px;

          &:hover {
            background: #475981;
            transform: translateY(-1px);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }

          &:active {
            transform: translateY(0);
          }
        }
      }

      .cardContent {
        padding: 12px;
        cursor: pointer;

        .company {
          font-size: 14px;
          font-weight: 600;
          color: #222;
          margin-bottom: 4px;
        }

        .position {
          font-size: 13px;
          font-weight: 500;
          color: #576B95;
          margin-bottom: 8px;
        }

        .divider {
          height: 1px;
          background-color: #f0f0f0;
          margin: 8px 0;
        }

        .intro {
          font-size: 12px;
          color: #666;
          line-height: 1.4;
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 5px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-right-color: #ffffff;
      }
    }
  }
}

.email-form {
  padding: 15px;
  .submit-btn {
    margin-top: 15px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
